import { faqPagesBodySchema } from "@redotech/redo-model/faq/faq-body-schema";
import * as z from "zod/v4";

export const createFaqPage = {
  name: "createFaqPage" as const,
  input: z.object({
    title: z.string(),
    description: z.string().optional(),
    published: z.boolean(),
  }),
  output: z.union([
    z.object({ success: z.literal(true), data: faqPagesBodySchema }),
    z.object({ success: z.literal(false), error: z.string() }),
  ]),
};
